export default __webpack_public_path__ + "static/media/cleaning-tools.eb053034.png";